import { type FC } from 'react';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const statusMap: Record<string, string> = {
  // Lead statuses
  'Novo': 'bg-blue-50 text-blue-700 border-blue-200',
  'Triagem': 'bg-amber-50 text-amber-700 border-amber-200',
  'Aguardando documentos': 'bg-orange-50 text-orange-700 border-orange-200',
  'Análise paga': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  'Proposta enviada': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'Contrato enviado': 'bg-violet-50 text-violet-700 border-violet-200',
  'Pago': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Caso ativo': 'bg-primary-50 text-primary-700 border-primary-200',
  'Perdido': 'bg-red-50 text-red-700 border-red-200',

  // Case statuses
  'Análise inicial': 'bg-blue-50 text-blue-700 border-blue-200',
  'Documentos pendentes': 'bg-orange-50 text-orange-700 border-orange-200',
  'Ativo': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Peça em elaboração': 'bg-violet-50 text-violet-700 border-violet-200',
  'Protocolado': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  'Aguardando decisão': 'bg-amber-50 text-amber-700 border-amber-200',
  'Audiência marcada': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'Finalizado': 'bg-gray-50 text-gray-600 border-gray-200',
  'Arquivado': 'bg-gray-100 text-gray-500 border-gray-200',

  // Payment statuses
  'Aguardando pagamento': 'bg-amber-50 text-amber-700 border-amber-200',
  'Parcialmente pago': 'bg-orange-50 text-orange-700 border-orange-200',
  'Vencido': 'bg-red-50 text-red-700 border-red-200',
  'Inadimplente': 'bg-red-100 text-red-800 border-red-300',
  'Cancelado': 'bg-gray-100 text-gray-500 border-gray-200',

  // Publication statuses
  'Nova': 'bg-blue-50 text-blue-700 border-blue-200',
  'Em análise': 'bg-amber-50 text-amber-700 border-amber-200',
  'Prazo sugerido': 'bg-orange-50 text-orange-700 border-orange-200',
  'Tarefa criada': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Vinculada ao caso': 'bg-primary-50 text-primary-700 border-primary-200',
  'Descartada': 'bg-gray-100 text-gray-500 border-gray-200',
  'Concluída': 'bg-emerald-50 text-emerald-700 border-emerald-200',

  // Task statuses
  'A fazer': 'bg-gray-50 text-gray-600 border-gray-200',
  'Em andamento': 'bg-blue-50 text-blue-700 border-blue-200',
  'Aguardando terceiro': 'bg-amber-50 text-amber-700 border-amber-200',
  'Cancelada': 'bg-red-50 text-red-700 border-red-200',

  // Client statuses
  'Documentação completa': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Caso urgente': 'bg-red-50 text-red-700 border-red-200',

  // Generic
  'Concluído': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Pendente': 'bg-amber-50 text-amber-700 border-amber-200',
  'Urgente': 'bg-red-50 text-red-700 border-red-200',
};

const StatusBadge: FC<StatusBadgeProps> = ({ status, size = 'sm' }) => {
  const classes = statusMap[status] || 'bg-gray-50 text-gray-600 border-gray-200';
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full border font-medium whitespace-nowrap ${sizeClasses} ${classes}`}>
      {status}
    </span>
  );
};

export default StatusBadge;